/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Error_DuplicateInputs */

const en_company_registration_error_duplicate = /** @type {(inputs: Company_Registration_Error_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A registration with this email address is already under review.`)
};

const de_company_registration_error_duplicate = /** @type {(inputs: Company_Registration_Error_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Registrierung mit dieser E-Mail-Adresse wird bereits geprüft.`)
};

/**
* | output |
* | --- |
* | "A registration with this email address is already under review." |
*
* @param {Company_Registration_Error_DuplicateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_error_duplicate = /** @type {((inputs?: Company_Registration_Error_DuplicateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Error_DuplicateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_error_duplicate(inputs)
	return en_company_registration_error_duplicate(inputs)
});